// What the user calls the assistant (Settings > Assistant memory, or by
// telling it). Kept to one short line; empty means it hasn't been named.
export const MAX_NAME = 40;

export const cleanName = (name) => String(name || '').replace(/\s+/g, ' ').trim().slice(0, MAX_NAME);

export const assistantName = (profile) => cleanName(profile?.assistantName);
